import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=a9f27f60"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9f27f60')) {
      api.createRecord('a9f27f60', component.options)
    } else {
      api.reload('a9f27f60', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=a9f27f60", function () {
      api.rerender('a9f27f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customer_dashboard/tax_return/Details.vue"
export default component.exports